import { OnyxAddressType } from '@onyx/angular';
import { OrderPointType } from '../../../dashboard/orders/common/enums/order-point-type';
import type { TransitPoint } from '../../interfaces/transit/transit-point';

export const TUNNELS = {
  /* France */
  frejusTunnelFrance: {
    id: 'frejus-tunnel-france',
    type: OrderPointType.TUNNEL,
    name: 'Fréjus Tunnel',
    address: {
      label: '73500 Modane, FR',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '73500',
      city: 'Modane',
      countryCode: 'fr',
      coordinates: {
        latitude: 45.195632182775604,
        longitude: 6.6754767311406,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Tunnel du Fréjus Traversée France-Italia',
    },
    phone: null,
  },
  montBlancTunnelFrance: {
    id: 'mont-blanc-tunnel-france',
    type: OrderPointType.TUNNEL,
    name: 'Mont Blanc Tunnel',
    address: {
      label: 'Tunnel du Mont-Blanc, 74400 Chamonix-Mont-Blanc, FR',
      street: 'Tunnel du Mont-Blanc',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '74400',
      city: 'Chamonix-Mont-Blanc',
      countryCode: 'fr',
      coordinates: {
        latitude: 45.90117863006393,
        longitude: 6.8613644761707215,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Tunnel du Mont-Blanc',
    },
    phone: {
      areaCode: '+33',
      number: '450555500',
    },
  },

  /* Italy */
  frejusTunnelItaly: {
    id: 'frejus-tunnel-italy',
    type: OrderPointType.TUNNEL,
    name: 'Fréjus Tunnel',
    address: {
      label: 'Piazzale della Difensiva, 10052 Bardonecchia TO, IT',
      street: 'Piazzale della Difensiva',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '10052',
      city: 'Bardonecchia TO',
      countryCode: 'it',
      coordinates: {
        latitude: 45.086764878197485,
        longitude: 6.71357203114308,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Sitaf SpA - Traforo del Frejus T4',
    },
    phone: {
      areaCode: '+39',
      number: '0122909011',
    },
  },
  montBlancTunnelItaly: {
    id: 'mont-blanc-tunnel-italy',
    type: OrderPointType.TUNNEL,
    name: 'Mont Blanc Tunnel',
    address: {
      label:
        'Piazzale Superstrada Traforo del Monte Bianco, 11013 Courmayeur, IT',
      street: 'Piazzale Superstrada Traforo del Monte Bianco',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '11013',
      city: 'Courmayeur',
      countryCode: 'it',
      coordinates: {
        latitude: 45.817016769570145,
        longitude: 6.952313489678145,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Geie Tunnel Del Monte Bianco',
    },
    phone: {
      areaCode: '+39',
      number: '0165890411',
    },
  },
} as const satisfies Record<TransitPoint['id'], TransitPoint>;
